// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Xp-z","breadcrumbForward":"Yp-z","breadcrumbBack":"Zp-z","selected":"_p-z"};